// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type PhoneNumber } from "../../api";
import { useGetPhoneNumber as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function usePhoneNumberQueryKey(phoneNumberId: string): QueryKey {
  return ["api", "v1", "phonenumbers", phoneNumberId];
}

export function usePhoneNumber(
  phoneNumberId: string,
  options: Omit<
    UseQueryOptions<PhoneNumber, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): PhoneNumber {
  const getter = useGetter();
  return useQuery(
    usePhoneNumberQueryKey(phoneNumberId),
    () => getter(phoneNumberId),
    options
  ).data!;
}
